module.exports = __webpack_public_path__ + "img/raipur-modified.5432b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/offices/raipur-modified.png
// module id = 1511
// module chunks = 1